import { useEffect, useState } from 'react'

export const MOBILE_QUERY = '(max-width: 640px)'
export const PHONE_QUERY = '(max-width: 767px)'

export const isMobileViewportInitial = (query = MOBILE_QUERY): boolean =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia(query).matches

export const useIsMobile = (query = MOBILE_QUERY): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(() => isMobileViewportInitial(query))

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return
    const mediaQuery = window.matchMedia(query)
    const handler = (event: MediaQueryListEvent) => setIsMobile(event.matches)
    mediaQuery.addEventListener('change', handler)
    return () => mediaQuery.removeEventListener('change', handler)
  }, [query])

  return isMobile
}

export const useIsPhone = (): boolean => useIsMobile(PHONE_QUERY)
